import React, { useEffect, useCallback, useRef } from 'react'
import { VariableSizeList as List } from 'react-window';


const RenderMenuList = (props: any) => {
    const { options, children, maxHeight, getValue, itemSize } = props;
    const [value] = getValue();
    const listRef = useRef<any>(null);

    const sizeMap = useRef<{ [index: number]: number }>({});

    // Memoized function to measure the height of each item
    const getItemSize = useCallback((index: number) => {
        if (sizeMap.current[index]) {
            return sizeMap.current[index];
        }
        const item = children[index];
        const height = item ? item.props.label.length <= 20 ? 40 : 35 + item.props.label.length : 40; // Example logic for dynamic height
        sizeMap.current[index] = height;
        return height;
    }, [children]);

    useEffect(() => {
        if (listRef.current) {
            listRef.current.resetAfterIndex(0, true); // Reset the list after height measurement
        }
    }, [children, getItemSize]);

    const dynamicHeight = children.length * getItemSize(options.indexOf(value));

    return (
        <div style={{ width: '100%' }}>
            <List
                ref={listRef}
                width="100%"
                height={dynamicHeight > maxHeight ? maxHeight : dynamicHeight}
                itemCount={children.length}
                itemSize={getItemSize}
                initialScrollOffset={options.indexOf(value) * getItemSize(options.indexOf(value))}
            >
                {({ index, style }) => (
                    <div style={{ ...style }}>
                        {children[index]}
                    </div>
                )}
            </List>
        </div>
    );
}

export default RenderMenuList